import {debugLog} from "../Utils/LogUtils";
import { useEffect } from 'react';
import moment from 'moment';
import {maxCarryForwardGrantRoom} from "../Utils/PlanUtils";

export default function useValidateMaximumCarryForwardGrantRoom(state) {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!state.beneficiary.birthdate) { return; }
        const maxGrantRoom = maxCarryForwardGrantRoom(state);
        if (state.plan.grantRoom > maxGrantRoom) {
            state.setPlan(prevData => ({...prevData, grantRoom: maxGrantRoom}));
        }
        debugLog("useValidateMaximumCarryForwardGrantRoom");
    }, [state.beneficiary.birthdate, state.plan.grantRoom]);
}